import { Loader2 } from 'lucide-react'
import type { AssistantJobRun } from '../api/assistant-api'

export function AssistantJobProgress({ job }: { job: AssistantJobRun }) {
  return (
    <div className="rounded-md border border-border bg-card p-2 text-xs flex items-center gap-2">
      <Loader2 className="w-3 h-3 animate-spin" />
      <span className="font-medium">{job.stage || 'در حال پردازش'}</span>
      <span className="text-muted-foreground truncate">{job.message}</span>
      <span className="ms-auto text-muted-foreground tabular-nums">
        {Math.round((job.progress || 0) * 100)}%
      </span>
    </div>
  )
}
